import { css, cx } from "@emotion/css";
import { MenuItemButton } from "@octopusdeploy/design-system-components";
import { CheckIcon } from "@octopusdeploy/design-system-icons";
import { space, themeTokens } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
import type { ExpandMode } from "./TaskLog";
interface ExpandCollapseItemButtonProps {
    expandMode: ExpandMode;
    label: string;
    selectedExpandMode: ExpandMode;
    expand: (expandMode: ExpandMode) => void;
}
export const ExpandCollapseItemButton = ({ expandMode, label, selectedExpandMode, expand }: ExpandCollapseItemButtonProps) => {
    const isSelected = selectedExpandMode === expandMode;
    return (<MenuItemButton onClick={() => expand(expandMode)}>
            <div className={cx(itemButtonStyles.parentContainer, { [itemButtonStyles.selected]: isSelected })}>
                <div className={itemButtonStyles.iconContainer}>{isSelected && <CheckIcon size={24}/>}</div>
                <div>{label}</div>
            </div>
        </MenuItemButton>);
};
const itemButtonStyles = {
    parentContainer: css({
        display: "flex",
        gap: space[12],
    }),
    selected: css({
        color: themeTokens.color.text.selected,
    }),
    iconContainer: css({
        minWidth: space[24],
        minHeight: space[24],
    }),
};
